/**
 * 땅주인 전용 API fetch 래퍼
 * owner_token (localStorage)을 Bearer로 자동 첨부
 */

const API_BASE = import.meta.env.VITE_API_URL || "";

export function ownerApiFetch(
  path: string,
  init: RequestInit = {},
): Promise<any> {
  const token = localStorage.getItem("owner_token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(init.headers as Record<string, string>),
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  return fetch(`${API_BASE}${path}`, { ...init, headers }).then(async (res) => {
    if (res.status === 401) {
      localStorage.removeItem("owner_token");
      localStorage.removeItem("owner_info");
      window.location.href = "/owner/login";
      return;
    }
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "오류가 발생했습니다");
    return data;
  });
}

export function ownerApiFetchPublic(
  path: string,
  init: RequestInit = {},
): Promise<any> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(init.headers as Record<string, string>),
  };
  return fetch(`${API_BASE}${path}`, { ...init, headers }).then(async (res) => {
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "오류가 발생했습니다");
    return data;
  });
}

export { API_BASE };
